import React from 'react';
import UseCaseCard from './useCaseCard.jsx';
import UseCasesHeader from './useCasesHeader.jsx';
import CmsService from '../js/cmsService.js';
import PreferenceService from '../js/preferenceService.js';

let cmsService = new CmsService();
let prefService = new PreferenceService();
const fullyQualifiedNameForProjects = "IntentGate.selected.projects";
const fullyQualifiedNameForSources = "IntentGate.selected.sources";
const fullyQualifiedNameForTrial = "IntentGate.skipTrial";

class UseCasesScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {useCases: [],
        selectedSourceTypes: this.props.selectedSourceTypes,
        selectedProjectTypes: this.props.selectedProjectTypes,
        hasPreferenceAlreadyStoredForProjects : this.props.selectedProjectTypes.length > 0 ? true : false,
        hasPreferenceAlreadyStoredForSourceTypes : this.props.selectedSourceTypes.length > 0 ? true : false,
        selectedProjectTypesMap: this._arrayToObjectMap(this.props.selectedProjectTypes),
        selectedSourceTypesMap: this._arrayToObjectMap(this.props.selectedSourceTypes)
    };
  }

  handleAction = (action, useCaseId) => {
    this.props.onUseCaseAction(action, useCaseId);
  }

  componentDidMount() {
    const that = this;
    cmsService.getUseCases().then(useCasesData => {
      const useCases = useCasesData.map((useCaseData) => {
        const { id: useCaseId, title, description } = useCaseData;
        const actions = {};

        if (useCaseData.walkthroughId) {
          actions.hasWalkthrough = true;
        }
        if (useCaseData.videoUrl) {
          actions.hasVideo = true;
        }
        let tags = [];
        if (useCaseData.intentTags) {
          tags = useCaseData.intentTags
            .filter(intent => intent.fields !== undefined) // Needed in case the linked entries are not published in Contentful
            .map(function (intent) {
              return intent.fields.tag;
            });
        }

        let element = <UseCaseCard
          content={this.props.content}
          key={useCaseId}
          title={title}
          description={description}
          onAction={this.handleAction} useCaseId={useCaseId} actions={actions}/>;

        return {element: element, tags: tags};
      });
      this.setState({ useCases });
    });
  }

  _arrayToObjectMap(inputArray) {
    const object = {};
    inputArray.map(function (key) {
      object[key] = true;
    });

    return object;
  }

  handleIntentsChanged = (type, selection) => {
    if (type === 'SOURCES') {
      this.handlesSourceTypeSelected(selection);
    } else if (type === 'PROJECTS') {
      this.handleProjectTypeSelected(selection);
    }
  }

  handleProjectTypeSelected(selection) {
    this.setState({selectedProjectTypes: selection, selectedProjectTypesMap: this._arrayToObjectMap(selection)});
    prefService.storeData(fullyQualifiedNameForProjects, selection, this.state.hasPreferenceAlreadyStoredForProjects);
  }

  handlesSourceTypeSelected(selection) {
    this.setState({selectedSourceTypes: selection, selectedSourceTypesMap: this._arrayToObjectMap(selection)});
    prefService.storeData(fullyQualifiedNameForSources, selection, this.state.hasPreferenceAlreadyStoredForSourceTypes);
  }

  getUseCasesSortedByTags() {
    const elements = [];
    if (this.state.selectedProjectTypes.length > 0 || this.state.selectedSourceTypes.length > 0) {
      const that = this;
      const filteredUseCases = [];
      this.state.useCases.map(function (useCase) {
        var matchedIntents = 0;
        useCase.tags.map(function (tag) {
          if (that.state.selectedProjectTypesMap[tag] || that.state.selectedSourceTypesMap[tag]) {
            matchedIntents += 1;
          }
        });
        useCase.matchedIntents = matchedIntents;
        if (matchedIntents > 0) {
          filteredUseCases.push(useCase);
        }
      });
      filteredUseCases.sort(function (a, b) {
        if (a.matchedIntents > b.matchedIntents) {
          return -1;
        }
        if (a.matchedIntents < b.matchedIntents) {
          return 1;
        }
        // a must be equal to b
        return 0;
      });
      filteredUseCases.map(function (useCase) {
        if (useCase.matchedIntents > 0) {


          elements.push(useCase.element);
        }

      });
    }
    return elements;
  }

  changeContainerPosition = () => {
    setTimeout(function(){
      let container=document.getElementsByClassName('use-case-cards-container')[0];
      let header=document.getElementsByClassName('use-cases-header')[0];
      container.style.top=header.scrollHeight+'px';
    });
    //this.setState({cardsContainerTopPosition:cardsContainerTopPosition});
  }

  render() {
    return (
      <div className='use-cases-screen'>
        <UseCasesHeader
          title={this.props.content.title}
          headerContent={this.props.headerContent}
          selectedSources={this.state.selectedSourceTypes}
          selectedProjects={this.state.selectedProjectTypes}
          onIntentsChanged={this.handleIntentsChanged}
          onSizeChanged={this.changeContainerPosition}
          onSkip={this.props.onSkip}
          onBack={this.props.onBack}/>
        <div className='cool-background'></div>
        <div className='use-case-cards-container'>
          <div className='use-case-cards-grid'>
            {this.getUseCasesSortedByTags()}
          </div>
        </div>
      </div>);
  }
}

export default UseCasesScreen;


